var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import AElf from 'aelf-sdk';
export class WalletAccount {
    constructor(wallet) {
        this.wallet = wallet;
        this.address = wallet.address;
        this.privateKey = wallet.privateKey;
    }
    /**
     * @param hexString hex string
     * @returns hex string
     */
    sign(hexString) {
        return AElf.wallet.sign(hexString, this.wallet.keyPair);
    }
    encrypt(password, options) {
        return __awaiter(this, void 0, void 0, function* () {
            return AElf.wallet.keyStore.getKeystore(this.wallet, password, options);
        });
    }
    signTransaction(tx) {
        return __awaiter(this, void 0, void 0, function* () {
            return AElf.wallet.signTransaction(tx, this.wallet.keyPair);
        });
    }
}
